<template>
  <Link v-bind="$attrs">
    <slot name="default">{{ text }}</slot>
  </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
  components: {
    Link,
  },
  props: {
    text: String
  }
}
</script>
